import { render } from "./DetailKkp.vue?vue&type=template&id=e45b1cba&scoped=true"
import script from "./DetailKkp.vue?vue&type=script&lang=js"
export * from "./DetailKkp.vue?vue&type=script&lang=js"

import "./DetailKkp.vue?vue&type=style&index=0&id=e45b1cba&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e45b1cba"]])

export default __exports__